'use strict'

export default class HistoryController {

  /*@ngInject*/
  constructor ($http, $stateParams, $state) {
    this.$http = $http
    this.$stateParams = $stateParams
    this.$state = $state

    this.page = 1
    this.params = {
      offset: this.page - 1,
      pageSize: 100,
      sortBy: 'createdAt',
      order: -1
    }
  }

  $onInit () {
    if (this.$stateParams.page) {
      this.page = this.$stateParams.page
    }
    if (this.$stateParams.pageSize) {
      this.params.pageSize = this.$stateParams.pageSize
    }
    this.getDevices()
  }

  getDevices () {
    this.params.offset = (this.page - 1) * this.params.pageSize
    this.params.page = this.page
    this.$http.get('/api/devices/getGenHistory', {params: this.params}).then(res => {
      this.devices = res.data.data
    })
  }


  pageChanged () {
    this.$state.go('devices.history', {page: this.page, pageSize: this.params.pageSize})
  }

  // search (text) {
  //   this.$http.get(`/api/devices/search?search=${text}`).then(res => {
  //     this.devices = res.data.data
  //   })
  // }

}



// WEBPACK FOOTER //
// ./client/app/devices/history/history.controller.js